import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { FinanceTotals } from '../components/FinanceTotals';
import { Dropdown } from '../components/Dropdown';
import { FinancialInfo } from '../shared/types';
import { Label } from '../shared/styled';

interface BalanceCardProps {
    financialInfo: FinancialInfo;
    viewChartBy: string;
    onViewChartByChange: (value: string) => void;
}

export const BalanceCard: React.FC<BalanceCardProps> = ({
    financialInfo,
    viewChartBy,
    onViewChartByChange,
}) => {
    return (
        <Card>
            <BalanceInfo>
                <Label>
                    <FormattedMessage
                        id="Finance.Balance.Label"
                        defaultMessage="USD Balance"
                    />
                </Label>
                <FinanceTotals
                    totals={String(financialInfo.balance)}
                    growthpct={financialInfo.growthPct}
                />
            </BalanceInfo>
            <ChartControls>
                <ViewChartBy>
                    <span>View chart by</span>
                    <Dropdown
                        options={[
                            { label: 'Totals', value: 'Totals' },
                            { label: 'Territory', value: 'Territory' },
                            { label: 'Label', value: 'Label' },
                            { label: 'Artist', value: 'Artist' },
                            { label: 'Release', value: 'Release' },
                            { label: 'Track', value: 'Track' },
                        ]}
                        onChange={onViewChartByChange}
                        initialValue={viewChartBy}
                    />
                </ViewChartBy>
            </ChartControls>
        </Card>
    );
};

const Card = styled.div`
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 16px;
    }
`;

const BalanceInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

const ChartControls = styled.div`
    display: flex;
    padding-top: 15px;

    @media (max-width: 768px) {
        padding-top: 0;
        width: 100%;
    }
`;

const ViewChartBy = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    color: #7B7B7B;
    font-size: 14px;

    span {
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        width: 100%;
        font-size: 13px;
        gap: 6px;

        > div {
            flex: 1;
        }
    }
`;
